import React from 'react'
import "./Loading.css"

const Loading = () => {
  return (
    <h1 className='loadingMessage'>Heat Seeking... Please Wait</h1>
  )
}

export default Loading